<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../../assets/images/h1.png" class="steps step1" v-if="status==1">
      <img src="../../../assets/images/h2.png" class="steps step2" v-if="status==2">
      <img src="../../../assets/images/h3.png" class="steps step3" v-if="status==3">
      <img src="../../../assets/images/h4.png" class="steps step4" v-if="status==4">
      <img src="../../../assets/images/h5.png" class="steps step5" v-if="status==5">
      <div class="stepbtn" @click="nextStep(status)">
        {{ status == 1 ? "下一步" : status == 2 ? "下一步" : status == 3 ? "下一步" : status == 4 ? "下一步" : status == 5 ? "我知道了" : "我知道了" }}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
<!--    <breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'合同列表'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="合同编号" prop="idLike">
                <el-input v-model="q.idLike" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="客户名称" prop="customerNameLike">
                <el-input v-model="q.customerNameLike" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="产品编码/型号" prop="customerNameLike">
                <el-input v-model="q.mcodeNamelikeHetong" clearable placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="合同类型" prop="salechannelCodeLike">
                <brselect category="contract_category" :v="q.contractCatecory" v-model="q.contractCatecory" clearable
                          style="width:100%"/>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="链群" prop="lianqun"  v-if="q.contractCatecory == 'CT-DLS-KJ'">
                <el-select v-model="q.lianqun"  placeholder="请选择" clearable>
                  <el-option label="样本网" value="X02"></el-option>
                  <el-option label="药品网" value="X01"></el-option>
                  <el-option label="生物安全" value="X08"></el-option>
                  <el-option label="培养箱" value="X09"></el-option>
                  <el-option label="离心机" value="X10"></el-option>
                  <el-option label="疫苗网" value="X06"></el-option>
                  <el-option label="血液网" value="X05"></el-option>
                  <el-option label="鸿鹄" value="X12"></el-option>
                  <el-option label="康盛" value="X13"></el-option>
                  <el-option label="海盛杰" value="X04"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="经销商合同类型" prop="status"  v-if="q.contractCatecory == 'CT-DLS-KJ'">
                  <brselect category="contract_agent" :v="q.contractAgent" v-model="q.contractAgent" clearable
                            style="width:100%"/>
              </el-form-item>
              <el-form-item label="框架合同状态" prop="status"  v-if="q.contractCatecory == 'CT-DLS-KJ'">
                <el-select v-model="q.status"  placeholder="请选择" clearable>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="审批中" value="1"></el-option>
                  <el-option label="驳回" value="2"></el-option>
                  <el-option label="暂存" value="3"></el-option>
                  <el-option label="已作废" value="4"></el-option>
                  <el-option label="已变更" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年份" prop="status"  v-if="q.contractCatecory == 'CT-DLS-KJ'">
                <el-select v-model="q.year"  placeholder="请选择" clearable>
                  <el-option label="2023" value="2023"></el-option>
                  <el-option label="2024" value="2024"></el-option>
                  <el-option label="2025" value="2025"></el-option>
                  <el-option label="2026" value="2026"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractName" v-if="q.contractCatecory == 'CT-DLS-KJ'">
                <el-select v-model="q.contractName" placeholder="请选择" >
                  <el-option value="国内市场经销合同">国内市场经销合同</el-option>
                  <el-option value="国内市场经销合同-血液">国内市场经销合同-血液</el-option>
                  <el-option value="国内市场经销合同-朗康">国内市场经销合同-朗康</el-option>
                  <el-option value="国内市场线上矩阵合同">国内市场线上矩阵合同</el-option>
                  <el-option value="康盛合同">康盛合同</el-option>
                  <el-option value="鸿鹄合同">鸿鹄合同</el-option>
                  <el-option value="海盛杰合同">海盛杰合同</el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="国内市场合同类型" class="h-elformWrap-2" prop="contractName" v-if="q.contractCatecory == 'CT-DLS-KJ'">
                <el-select v-model="q.contractKjType" placeholder="请选择" >
                  <el-option value="主合同">主合同</el-option>
                  <el-option value="子合同">子合同</el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售区域" class="h-elformWrap-2" prop="contractName" v-if="q.contractCatecory == 'CT-DLS-KJ'">
                <brselect category="YlSalesArea_chanpin" :v="q.saleareaCode" v-model="q.saleareaCode" clearable
                          style="width:100%"/>
              </el-form-item>
              <el-form-item label="补充协议状态" prop="status"  v-if="q.contractCatecory == 'CT-DLS-KJ'">
                <el-select v-model="q.isShhm"  placeholder="请选择" clearable>
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="审批中" value="2"></el-option>
                  <el-option label="驳回" value="3"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item class="right-btn">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button @click="resetData" class="h-btn h-formBtn h-bgwhite">重置</el-button>
                <el-button v-auth="'createContract'" class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                           @click="xinzenghetong">新增合同
                </el-button>
                <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" v-if="dlsflag"
                           @click="xinzenghetongJingxiaoshang">新增经销商框架合同
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

      </div>
      <div class="h-table h-mrt30">
        <el-table
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="tableData2"
            stripe
            style="width: 100%"
            :border="true"
            max-height="450"
        >
          <el-table-column
              type="selection"
              width="40"
              label="全选"
          >
          </el-table-column>
          <el-table-column
              fixed
              type="index"
              label="#"
              width="40">
          </el-table-column>
          <el-table-column
              prop="contractName"
              label="合同名称"
              :show-overflow-tooltip="true"
              min-width="180">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.contractName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="id"
              label="合同编号"
              :show-overflow-tooltip="true"
              width="160">
          </el-table-column>
          <el-table-column
              prop="customerName"
              label="客户名称"
              min-width="180"
              :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.customerName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="contractAmount"
              label="合同金额"
              v-if="dlsflag"
              min-width="100"
              :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.contractAmount }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="saleareaCode"
            label="销售区域"
            width="100">
            <template slot-scope="scope">
                <dictname category="YlSalesArea" :v="scope.row.saleareaCode"/>
            </template>
          </el-table-column> -->
          <!--<el-table-column-->
          <!--prop="salechannelCode"-->
          <!--label="销售渠道"-->
          <!--width="90">-->
          <!--<template slot-scope="scope">-->
          <!--<dictname category="sales_region" :v="scope.row.salechannelCode"/>-->
          <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
          <!--prop="payCondition"-->
          <!--label="付款条件"-->
          <!--:show-overflow-tooltip="true"-->
          <!--width="90">-->
          <!--</el-table-column>-->
          <el-table-column
              prop="contractCatecory"
              label="合同类型"
              :show-overflow-tooltip="true"
              width="100">
            <template slot-scope="scope">
              <dictname category="contract_category" :v="scope.row.contractCatecory"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="contractAgent"
              v-if="dlsflag"
              label="经销商合同类型"
              :show-overflow-tooltip="true"
              width="120">
            <template slot-scope="scope">
              <dictname category="contract_agent" v-if="scope.row.contractName !== '国内市场线上矩阵合同'" :v="scope.row.contractAgent"/>
              <dictname category="contract_xianshang" v-if="scope.row.contractName === '国内市场线上矩阵合同'" :v="scope.row.contractAgent"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="oneLevelAgentName"
              label="对阵一级经销商"
              :show-overflow-tooltip="true"
              width="120">
            <template slot-scope="scope">
              {{scope.row.oneLevelAgentName | dictname('xsyb_lianqun')}}
            </template>
          </el-table-column>
          <el-table-column label="销售省区" class="h-elformWrap-2" prop="saleareaCode" v-if="dlsflag">
            <template slot-scope="scope">
              <dictname category="YlSalesArea_chanpin" :v="scope.row.saleareaCode"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="salesCityName"
              label="销售地市"
              v-if="dlsflag ||hhflag"
              min-width="100"
              :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.salesCityName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="销售渠道"
                           class="h-elformWrap-2"
                           prop="salechannelCode"
                           width="100"
                           :show-overflow-tooltip="true"
                           v-if="dlsflag">
              <template slot-scope="scope">
                <div v-if="scope.row.contractName !== '国内市场线上矩阵合同'">
                  {{scope.row.salechannelCode | dictname('sales_region')}}
                </div>
                <div v-if="scope.row.contractName==='国内市场线上矩阵合同'">
                  {{scope.row.salechannelCode | dictname('xinshangpingtai')}}
                </div>

              </template>
          </el-table-column>
          <el-table-column
              prop="status"
              v-if="dlsflag || hhflag"
              label="状态"
              :show-overflow-tooltip="true"
              align="center"
              width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.status=='0'">正常</div>
              <div v-if="scope.row.status=='1'">审批中 </div>
              <div v-if="scope.row.status=='2'">驳回</div>
              <div v-if="scope.row.status=='3'">暂存</div>
              <div v-if="scope.row.status=='4'">已作废</div>
              <div v-if="scope.row.status=='5'">已变更</div>
            </template>
          </el-table-column>
          <el-table-column
                  prop="pass"
                  v-if="dlsflag"
                  label="附表审核状态"
                  :show-overflow-tooltip="true"
                  align="center"
                  width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.pass=='1'">通过</div>
              <div v-if="scope.row.pass=='2'">审批中 </div>
              <div v-if="scope.row.pass=='3'">驳回 </div>
              <div v-if="scope.row.pass=='0'">未提交 </div>
            </template>
          </el-table-column>
          <el-table-column
                  prop="isShhm"
                  v-if="dlsflag"
                  label="补充协议状态"
                  :show-overflow-tooltip="true"
                  align="center"
                  width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.isShhm==1">通过</div>
              <div v-if="scope.row.isShhm==2">审批中 </div>
              <div v-if="scope.row.isShhm==3">驳回 </div>
              <div v-if="scope.row.isShhm==0 || scope.row.isShhm==''">未提交 </div>
            </template>
          </el-table-column>
          <!--<el-table-column-->
          <!--prop="contractStatus"-->
          <!--label="合同状态"-->
          <!--width="90"-->
          <!--&gt;-->
          <!--</el-table-column>-->
          <el-table-column
              prop="chuangjiarn"
              label="维护人"
              width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.cuname }}[{{ scope.row.cucode }}]
            </template>
          </el-table-column>
          <el-table-column
              prop="contractStarttime"
              label="开始时间"
              :show-overflow-tooltip="true"
              width="110"
          >
          </el-table-column>
          <el-table-column
              prop="contractEndtime"
              label="结束时间"
              :show-overflow-tooltip="true"
              width="110"
          >
          </el-table-column>
          <el-table-column
              label="操作"
              fixed="right"
              width="400"
          >
            <template slot-scope="scope">
              <!-- <router-link v-if="scope.row.editStatus===0"
              :to="{path:'/contract-new2',query:{id:scope.row.id}}"> -->
              <div style="text-align: left;">
                <el-button @click="adjustment(scope.row.id)"
                           type="text" v-if="scope.row.contractCatecory == 'CT-CG'"
                           size="small"
                           class="h-tableLink h-btn">
                  调整
                </el-button>
                <el-button
                    v-if=" scope.row.contractCatecory == 'CT-CG' "
                    style="margin-left: 0"
                    @click="updatePage(scope.row.id)"
                    type="text"
                    size="small"
                    class="h-tableLink h-btn">
                  修改
                </el-button>
                <el-button @click="editPage(scope.row.contractType, scope.row.id)"
                           type="text" v-if="scope.row.editStatus===0"
                           size="small"
                           class="h-tableLink h-btn">
                  编辑
                </el-button>
                <!-- </router-link> -->
                <router-link :to="{path:'/contract-detail', query: {key: scope.row.id}}" v-if="scope.row.contractCatecory!='CT-DLS-KJ' && scope.row.contractCatecory!='CT-HT' && scope.row.contractCatecory!='CT-XS'">
                  <el-button
                      type="text"
                      size="small"
                      class="h-tableLink h-btn">
                    查看
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-hhxm-detaili', query: {key: scope.row.id}}" v-if="scope.row.contractCatecory=='CT-HT'">
                  <el-button
                          type="text"
                          size="small"
                          class="h-tableLink h-btn">
                    查看
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-xs-detaili', query: {key: scope.row.id}}" v-if="scope.row.contractCatecory=='CT-XS'">
                  <el-button
                      type="text"
                      size="small"
                      class="h-tableLink h-btn">
                    查看
                  </el-button>
                </router-link>

                <el-button
                        v-if="scope.row.contractCatecory=='CT-DLS-KJ' && (scope.row.pid != null && scope.row.pid != '') && (scope.row.status === 3 || scope.row.status===2)"
                        type="text"
                        size="small"
                        @click="chooseKj(scope.row.id)"
                        class="h-tableLink h-btn">
                  子合同下载
                </el-button>
                <router-link :to="{path:'/contract-agent', query: {key: scope.row.id}}">
                  <el-button type="text" v-if="scope.row.status===3 && scope.row.contractCatecory=='CT-DLS-KJ' && (scope.row.pid != null && scope.row.pid != '')"
                             size="small"
                             class="h-tableLink h-btn">
                    子合同上传
                  </el-button>
                </router-link>
                <el-button
                        v-if="scope.row.status===0 && (scope.row.contractName==='国内市场经销合同-朗康' || scope.row.contractName==='国内市场经销合同')
                         && scope.row.contractAgent != 4  && scope.row.contractAgent != 5   && scope.row.contractAgent != 6
                         && scope.row.contractCatecory=='CT-DLS-KJ' && (scope.row.pid == null || scope.row.pid == '')"
                        type="text"
                        size="small"
                        @click="chooseKj(scope.row.id,scope.row.customerName)"
                        class="h-tableLink h-btn">
                  详情附表
                </el-button>
                <router-link :to="{path:'/contract-agent-see', query: {key: scope.row.id,isFb:1}}">
                  <el-button type="text" v-if="scope.row.status===0 && (scope.row.pass == '' || scope.row.pass == null || scope.row.pass == 3) && scope.row.contractCatecory=='CT-DLS-KJ' && (scope.row.pid == null || scope.row.pid == '')
                                         && scope.row.contractAgent != 4  && scope.row.contractAgent != 5   && scope.row.contractAgent != 6 && scope.row.contractName==='国内市场经销合同'
                                      "
                             size="small"
                             class="h-tableLink h-btn">
                    附表上传
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agentnew', query: {key: scope.row.id,update:0}}">
                  <el-button type="text" v-if="scope.row.status===3 && scope.row.contractCatecory=='CT-DLS-KJ' && (scope.row.pid == null || scope.row.pid == '')
                                      && scope.row.contractAgent != 4  && scope.row.contractAgent != 5   && scope.row.contractAgent != 6
                                  "
                             size="small"
                             class="h-tableLink h-btn">
                    编辑
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-hhxm-shenpi', query: {key: scope.row.id,updateContract: 1}}">
                  <el-button type="text" v-if="scope.row.status===3 && scope.row.contractCatecory=='CT-HT'"
                             size="small"
                             class="h-tableLink h-btn">
                    编辑
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agentnew', query: {key: scope.row.id,update:2}}">
                  <el-button type="text" v-if="scope.row.status===0 && scope.row.contractCatecory=='CT-DLS-KJ' && scope.row.contractName !=='国内市场线上矩阵合同'"
                             size="small"
                             class="h-tableLink h-btn">
                    修改
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agentnew-xianshang', query: {key: scope.row.id,update:2}}">
                  <el-button type="text" v-if="scope.row.status===0 && scope.row.contractCatecory=='CT-DLS-KJ' && scope.row.contractName ==='国内市场线上矩阵合同'"
                             size="small"
                             class="h-tableLink h-btn">
                    修改
                  </el-button>
                </router-link>

                <router-link :to="{path:'/contract-agentnew', query: {key: scope.row.id,update:0}}">
                  <el-button type="text" v-if="scope.row.status===2 && scope.row.contractCatecory=='CT-DLS-KJ' && scope.row.contractName !=='国内市场线上矩阵合同'"
                             size="small"
                             class="h-tableLink h-btn">
                    重新提交
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agentnew', query: {key: scope.row.id,update:0}}">
                  <el-button type="text" v-if="scope.row.status===2 && scope.row.contractCatecory=='CT-DLS-KJ' && scope.row.contractName ==='国内市场线上矩阵合同'"
                             size="small"
                             class="h-tableLink h-btn">
                    重新提交
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-hhxm-shenpi', query: {key: scope.row.id,updateContract: 1}}">
                  <el-button type="text" v-if="(scope.row.status===2 || scope.row.status===0) && scope.row.contractCatecory=='CT-HT'"
                             size="small"
                             class="h-tableLink h-btn">
                    重新提交
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-new2', query: {contractId: scope.row.id}}"  v-if="scope.row.status===2 && scope.row.contractCatecory=='CT-CG'">
                  <el-button type="text"
                             size="small"
                             class="h-tableLink h-btn">
                    重新提交
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agent-see', query: {key: scope.row.id}}" v-if="scope.row.contractCatecory=='CT-DLS-KJ' && !(scope.row.contractName==='国内市场经销合同' || scope.row.contractName==='国内市场经销合同-血液' || scope.row.contractName==='国内市场线上矩阵合同')">
                  <el-button
                      type="text"
                      size="small"
                      class="h-tableLink h-btn">
                    查看
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agentshenpi', query: {key: scope.row.id}}" v-if="scope.row.contractCatecory=='CT-DLS-KJ'  && (scope.row.contractName==='国内市场经销合同' || scope.row.contractName==='国内市场经销合同-血液')">
                  <el-button
                          type="text"
                          size="small"
                          class="h-tableLink h-btn">
                    查看
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agentshenpixs', query: {key: scope.row.id}}" v-if="scope.row.contractCatecory =='CT-DLS-KJ'  && scope.row.contractName ==='国内市场线上矩阵合同'">
                  <el-button
                          type="text"
                          size="small"
                          class="h-tableLink h-btn">
                    查看
                  </el-button>
                </router-link>
                <router-link :to="{path:'/contract-agent-see', query: {key: scope.row.id,isXy:1}}" v-if="scope.row.contractCatecory=='CT-DLS-KJ' && scope.row.contractName==='国内市场经销合同' && scope.row.isShhm!=2 && (scope.row.pid == null || scope.row.pid == '') && scope.row.contractAgent == 1">
                  <el-button
                          type="text"
                          size="small"
                          class="h-tableLink h-btn">
                    补充协议
                  </el-button>
                </router-link>
                <el-button
                    v-if="scope.row.contractCatecory=='CT-DLS-KJ' && scope.row.status == 0 && zuofei"
                    @click="dlsCancel(scope.row.id)"
                    type="text"
                    size="small"
                    class="h-tableLink h-btn">
                  作废
                </el-button>

                <el-button @click="ylcspage(scope.row)"
                           type="text"
                           v-if="scope.row.contractCatecory=='CT-ZL'&&scope.row.editStatus==1&&scope.row.ylcsFlag==0"
                           size="small"
                           class="h-tableLink h-btn">
                  盈利测算
                </el-button>
                <el-button @click="freezeWindow(scope.row.id)"
                           type="text"
                           size="small"
                           v-if="scope.row.contractCatecory == 'CT-ZL'"
                           class="h-tableLink h-btn">
                  冻结/解除
                </el-button>
                <el-button @click="showcgdongjiewindow(scope.row.id)"
                           type="text"
                           size="small"
                           v-if="scope.row.contractCatecory == 'CT-CG' && scope.row.editStatus ==1"
                           class="h-tableLink h-btn">
                  冻结/解除
                </el-button>
                <el-button
                    type="text"
                    size="small" class="h-tableLink h-btn"
                    v-if="scope.row.instid"
                    @click="genzongLiuch(scope.row.instid)">
                  跟踪
                </el-button>
                <el-button
                        type="text"
                        size="small" class="h-tableLink h-btn"
                        v-if="scope.row.businessContractCode && dlsflag && scope.row.contractCatecory=='CT-DLS-KJ'"
                        @click="genzongLiuch(scope.row.businessContractCode)">
                  协议跟踪
                </el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button @click="exportExcel" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出
            </el-button>
            <el-button v-auth="'createContract'" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                       @click="uploaddownexcelflagbtn">批量导入
            </el-button>
            <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                             clsname="contractImportExcel"
                             :startrow="3" @callback="uploadExcelFilecallback"/>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

      <!-- 合同的冻结/解除 -->
      <el-dialog
          :visible.sync="freezeX"
          v-if="freezeX"
          class="h-dialog2"
      >
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>合同冻结与恢复</h1>
            </div>
          </div>
        </div>

        <div style="margin: 0.3rem 0.2rem;">
          <div class="h-pieceTitle2">
            <h1>付款节点</h1>
          </div>
          <el-form ref="form3">
            <el-table
                ref="multipleTable"
                :data="formInline.paymentList"
                style="width: 100%"
                max-height="400"
            >
              <el-table-column
                  type="index"
                  width="40"
                  label="#">
              </el-table-column>
              <el-table-column
                  prop="nodeName"
                  label="节点名称"
                  :show-overflow-tooltip="true">
                <template scope="scope">
                  {{ scope.row.nodeName }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentRatio"
                  label="付款比例(%)" width="115">
                <template scope="scope">
                  {{ scope.row.paymentRatio }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="paymentAmount"
                  label="开票金额" width="100">
                <template scope="scope">
                  {{ scope.row.paymentAmount }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="netValue"
                  label="净价值"
                  width="100">
                <template scope="scope">
                  {{ scope.row.netValue }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="freeze"
                  label="状态"
                  width="60">
                <template scope="scope">
                  <span v-if="scope.row.freeze==1">正常</span>
                  <span v-if="scope.row.freeze==0">冻结中</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="freeze"
                  label="操作"
                  width="90">
                <template scope="scope">
                                    <span v-if="scope.row.freeze==1">
                                        <el-button
                                            @click="exeFreeze(scope.row.id, scope.row.ccode, scope.row.posnr, '0')"
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn">
                                                冻结
                                        </el-button>
                                    </span>
                  <span v-if="scope.row.freeze==0">
                                        <el-button
                                            @click="exeFreeze(scope.row.id, scope.row.ccode, scope.row.posnr, '1')"
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn">
                                                恢复
                                        </el-button>
                                    </span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="freezeX = false">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 采购合同产品价格调整 -->
      <el-dialog
          :visible.sync="adjustmentX"
          v-if="adjustmentX"
          class="h-dialog2 dialog-chengprice"
      >
        <div class="h-dialogImg" style="background: none;height:0px;">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>产品价格调整</h1>
            </div>
          </div>
        </div>

        <div style="margin:0.3rem 0.2rem;">
          <div class="h-pieceTitle2">
            <h1>采购价格列表</h1>
          </div>
          <el-form ref="form3">
            <el-table
                ref="multipleTable"
                :data="formInline.productList"
                style="width: 100%"
                max-height="400"
            >
              <el-table-column
                  type="index"
                  label="#" width="40">
              </el-table-column>
              <el-table-column
                  prop="productId"
                  :show-overflow-tooltip="true"
                  width="120"
                  label="产品型号">
              </el-table-column>
              <el-table-column
                  prop="productName"
                  width="140"
                  :show-overflow-tooltip="true"
                  label="产品名称">
              </el-table-column>
              <el-table-column
                      prop="oemDesc"
                      width="140"
                      :show-overflow-tooltip="true"
                      label="规格型号">
              </el-table-column>
              <el-table-column
                  prop="unitPrice"
                  width="120"
                  label="产品价格">
                <template scope="scope">
                  <el-input v-model="scope.row.unitPrice" placeholder="" type="number"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="冻结状态"
                  width="80">
                <template scope="scope">
                  <span v-if="scope.row.status==1">正常</span>
                  <span v-if="scope.row.status==0">冻结中</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="cgstatus"
                  width="80"
                  label="是否可用">
                <template scope="scope">
                  <span v-if="scope.row.cgstatus==1">是</span>
                  <span v-if="scope.row.cgstatus==0" style="color:red;">否</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="shuilv"
                  label="发票税率">
                <template scope="scope">
                  <brselect category="cgshuilv" :v="scope.row.shuilv" disabled v-model="scope.row.shuilv"/>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div class="h-formLine h-mrt40 weekplandetail1">
          <el-form style="width:80%;" class="demo-ruleForm h-formbLine hetongfujian">
            <el-form-item label="合同附件" class="h-elformWrap h-formRbtnOut h-formRbtnOut2">
              <brupload :refid="this.selectedContractId" uploadflag delflag reftype="合同附件"></brupload>
            </el-form-item>
            <el-form-item label="变更附件" class="h-elformWrap h-formRbtnOut h-formRbtnOut2">
              <brupload :refid="this.selectedContractId" uploadflag delflag reftype="采购价变更附件"></brupload>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="adjustmentX = false">取 消</el-button>
          <el-button class="h-btn h-bBtn h-bgblue2" @click="exeAdjustment()">发起审批</el-button>
        </div>
      </el-dialog>

      <!-- 采购合同产品冻结 -->
      <el-dialog
          :visible.sync="cgdongjiewindow"
          v-if="cgdongjiewindow"
          class="h-dialog2"
      >
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>采购合同冻结与解冻</h1>
            </div>
          </div>
        </div>

        <div style="margin: 0.3rem 0.2rem;">
          <div class="h-pieceTitle2">
            <h1>采购产品</h1>
          </div>
          <el-form ref="form3">
            <el-table
                ref="multipleTable"
                :data="cgdongjieList"
                style="width: 100%"
                max-height="400"
            >
              <el-table-column
                  type="index"
                  width="40"
                  label="#">
              </el-table-column>
              <el-table-column
                  prop="productName"
                  label="产品名称"
                  :show-overflow-tooltip="true">
                <template scope="scope">
                  {{ scope.row.productName }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="productId"
                  label="产品编码" width="115">
                <template scope="scope">
                  {{ scope.row.productId }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="unitPrice"
                  label="产品价格"
                  width="115">
                <template scope="scope">
                  {{ scope.row.unitPrice }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="状态"
                  width="100">
                <template scope="scope">
                  <span v-if="scope.row.status==1">正常</span>
                  <span v-if="scope.row.status==0">冻结中</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="操作"
                  width="130">
                <template scope="scope">
                                    <span v-if="scope.row.status==1">
                                        <el-button @click="freezeWindowCGDJ(scope.row.id)"
                                                   type="text"
                                                   size="small"
                                                   class="h-tableLink h-btn">
                                                冻结
                                        </el-button>
                                    </span>
                  <span v-if="scope.row.status==0">
                                        <el-button @click="freezeWindowCGJD(scope.row.id)"
                                                   type="text"
                                                   size="small"
                                                   class="h-tableLink h-btn">
                                                解冻
                                        </el-button>
                                    </span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cgdongjiewindow = false">确 定</el-button>
        </div>
      </el-dialog>
      <contractadd :visible.sync="imgflag4" v-if="imgflag4" @imgfalse1="imgflag4=false"/>
    </div>
  </div>
</template>

<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile';
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

export default {
  components: {
    uploaddownexcel,
  },
  name: 'leftMenu',
  data() {
    return {
      selectedContractId: null,
      cghetongid: null,
      //冻结弹窗
      cgdongjiewindow: false,
      cgdongjieList: [],
      imgflag4: false,
      toshow: "hetongliebiao",
      status: 1,
      checked: true,
      showhistory: false,
      showOrhide: false,
      freezeX: false,
      adjustmentX: false,
      dlsflag:false,
      hhflag:false,
      zuofei:false,
      is1S00:false,
      //表单
      formInline: {},

      uploaddownexcelflag: false,
      hetongdex: 0,
      hetonglist: [
        {
          title: "线下合同",
          desc: '线下所签署的合同，提供电子版上传',
        },
        {
          title: "LEG合同",
          desc: 'LEG系统签署的合同，通过合同号关联',
        }
      ],
      //表格
      multipleSelection: [],
      tableData2: [],

      //弹框
      dialogFormVisible: false,
      formLabelAlign2: {
        formCon1: '',
        formCon2: '',
        formCon3: '',
      },
      checkboxGroup1: ['亚太'],
      cities: ['非洲', '亚太', 'UN'],
      q: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        idLike: null,
        customerNameLike: null,
        saleareaCodeLike: null,
        salechannelCodeLike: null,
        contractKjType:null,
        contractCatecory:null,
        year:null,
        contractName:null,
        status:null
      }
    }
  },
  methods: {
    genzongLiuch(q) {
      this.instid = q;
      this.showhistory = true;
    },
    ylcspage(data) {
      var url = this.$router.resolve({
        path: '/rateFormulaZulinshiti', query: {
          'cid': data.id,
          'z5': data.productCode, 'z18': data.customerCode, 'z20': data.customerName,
          'z7': data.rentTime, 'z8': data.contractStarttime
        }
      });
      window.open(url.href, "_blank");
    },
    showzhezhao() {
      ss.salesList.toshow(this.toshow).then(rd => {
        console.log(rd)
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },

    //加载冻结状态数据并弹窗
    freezeWindow(id) {
      ss.contractService.detail(id).then(rd => {
        this.formInline = rd.obj;
        console.log(this.formInline);
        this.freezeX = true;
        sessionStorage.setItem("OBJ01", id);
      });
    },

    //执行冻结/解除
    exeFreeze(id, cCode, posnr, flag) {
      var cp = {
        id: id,
        cCode: cCode,
        posnr: posnr,
        flag: flag,
      }
      ss.contractService.doFreeze(cp).then(rd => {
        this.$msg.msgs(rd.msg);
        this.freezeWindow(sessionStorage.getItem("OBJ01"));
      });
    },
    //采购产品弹窗
    showcgdongjiewindow(id) {
      this.cgdongjiewindow = true;
      this.cgproduct(id);
      this.cghetongid = id;
    },
    //查询采购产品
    cgproduct(v) {
      ss.contractService.findCGProduct(v).then(rd => {
        this.cgdongjieList = rd;
      });
    },
    //冻结
    freezeWindowCGDJ(id) {
      ss.contractService.freezeWindowCGDJ(id).then(rd => {
        this.$msg.msgs(rd.msg);
        this.cgproduct(this.cghetongid);
      });
    },
    //解除
    freezeWindowCGJD(id) {
      ss.contractService.freezeWindowCGJD(id).then(rd => {
        this.$msg.msgs(rd.msg);
        this.cgproduct(this.cghetongid);
      });
    },

    //加载产品价格数据并弹窗
    adjustment(id) {
      this.selectedContractId = id;
      ss.contractService.detail(id).then(rd => {
        this.formInline = rd.obj;
        console.log(this.formInline);
        this.adjustmentX = true;
        sessionStorage.setItem("OBJ02", id);
      });
    },

    //修改产品价格提交审批
    exeAdjustment() {
      this.formInline.productListS = this.formInline.productList;
      console.log(this.formInline.productListS);
      ss.contractService.insertS(this.formInline).then(rd => {
        this.$msg.msgs(rd.msg);
        this.query();
      });
      this.adjustmentX = false;
    },

    uploadExcelFilecallback() {
      this.query();
    },
    //导入
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    //重置
    resetData() {
      this.q.idLike = "";
      this.q.customerNameLike = "";
      this.q.mcodeNamelikeHetong = "";
      this.q.contractCatecory = "";
      this.q.lianqun = "";
      this.q.contractAgent  ="";
      this.q.status = "";
      this.q.year = "";
      this.q.contractName  = "";
      this.q.contractKjType = "";
      this.q.saleareaCode = "";
      this.q.isShhm = "";
    },
    //编辑
    editPage(contractType, id) {
      var url;
      if (contractType == 0) {
        url = this.$router.resolve({path: "/contract-new2", query: {contractId: id}});
      } else {
        url = this.$router.resolve({path: "/contract-new1", query: {contractId: id}});
      }
      window.open(url.href, "_blank");
    },
    // 修改
    updatePage(id) {
      var url = this.$router.resolve({path: "/contract-update", query: {contractId: id, key: id}});
      window.open(url.href, "_blank");
    },
    //导出
    chooseKj(value){
      ss.contractService.downAppealJy(value).then(res => {
        if(res.f){
          //导出明细
          updownfile.down('/api/swyl/v1/hetong/bscContract/downAppeal',{id:value},"get");
        }
      });
    },
    //导出
    exportExcel() {
      var idlist = [];
      this.multipleSelection.forEach(element => {
        idlist.push(element.id);
      });
      this.q.ids = idlist.join(",");
      updownfile.down("/api/swyl/v1/hetong/bscContract/downloadExcel", this.q);
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    hetongbtn(index) {
      this.hetongdex = index;
    },
    queren() {
      if (this.hetongdex == 0) {
        this.$router.push("/contract-new2")
        this.dialogFormVisible = false
      } else {
        this.$router.push("/contract-new1")
        this.dialogFormVisible = false
      }
    },
    //查询列表
    query(p) {
      ss.contractService.page(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData2 = rd.records;
      });
    },
    handleFilter() {
      this.query();
    },
    // 新手引导页
    nextStep(i) {
      if (this.status == 1) {
        this.status = 2;
      } else if (this.status == 2) {
        this.status = 3;
      } else if (this.status == 3) {
        this.status = 4;
      } else if (this.status == 4) {
        this.status = 5;
      } else if (this.status == 5) {
        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }

    },
    closeIt() {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    xinzenghetong() {
      this.$router.push("/contract-new2")
    },
    xinzenghetongJingxiaoshang() {
      this.$router.push("/contract-agentnew")
    },
    //代理商框架合同作废
    dlsCancel(query){
      this.$confirm('是否作废?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.$route.query.taskid != undefined){
          this.commitBaojiaData.taskid = this.$route.query.taskid;
        }
        ss.contractService.dlsCancel(query).then(rd=>{
            this.$message({
              type: 'success',
              message: '作废成功!'
            });
            this.query();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });
    }
  },
  mounted() {
    this.query();
  },
  created() {
    this.showzhezhao()
    if (this.$store.getters.hasRole('swyl_wanglgly,swyl_xiaoshoujl,SHICHANG_PINGTAI,swyl_admin,swyl_quyujl,swyl_daqujl,swyl_hh_kgs')) {
        this.dlsflag = true;
        if(this.$store.getters.hasRole("SHICHANG_PINGTAI")){
          this.q.contractCatecory = 'CT-DLS-KJ';
          this.q.year = '2026';
          this.q.contractName = '国内市场经销合同';
          this.q.status = '0'
          //进行强制数据渲染
          this.$forceUpdate();
        }
    }
    if (this.$store.getters.hasRole('hh_shichangneiqin')) {
      this.hhflag = true;
    }
    if (this.$store.getters.hasRole('swyl_admin,pingtaishenpi,swyl_wanglgly,swyl_kjht_zuofei')) {
      this.zuofei = true;
    }
  }
}
</script>
<style scoped lang="scss">

.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
}

.bottomTip2 {
  position: absolute;
  left: 50%;
  bottom: 0.1rem;
  transform: translateX(-50%);
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785E7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .steps {
    position: absolute;
    z-index: 1;
  }

  .step1 {
    top: 0.78rem;
    left: 0rem;
    width: 4.3rem;
    height: 8.1rem;
  }

  .step2 {
    top: 1.7rem;
    left: 2.95rem;
    width: 9rem;
    height: 1.6rem;
  }

  .step3 {
    top: 1.75rem;
    width: 2.2rem;
    height: 1.7rem;
    right: 0.7rem;
  }

  .step4 {
    top: 3.64rem;
    width: 3.6rem;
    height: 0.9rem;
    right: 0.6rem;
  }

  .step5 {
    top: 8.4rem;
    width: 5.85rem;
    height: 0.9rem;
    left: 2.7rem;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.75rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .stepbtn1 {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.45rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
  }
}
</style>
<style>
.dialog-chengprice .el-dialog {
  border-radius: 0.1rem;
  width: 12.89rem !important;
}
</style>
